import classNames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Button, Colors, Display } from 'Views/Components/Button/Button';
import LoaderInsideButton from 'Views/Components/Spinner/LoaderInsideButton';
import { TextInput } from 'Views/Components/New/TextInput';

export interface GiftCertificateProps {
	code: string;
	loading: boolean;
}

export type PromoGiftCardMessageType = 'error' | 'warning' | 'success';

export interface PromoGiftCardMessage {
	text: string;
	type: PromoGiftCardMessageType;
}

export interface PromoGiftCardInputProps {
	certificateProps: GiftCertificateProps;
	setCertificateProps: React.Dispatch<React.SetStateAction<GiftCertificateProps>>;
	onApply: () => void;
	message?: PromoGiftCardMessage | null;
	onCodeChange?: () => void;
}

function PromoGiftCardInput({
	certificateProps,
	setCertificateProps,
	onApply,
	message,
	onCodeChange,
}: PromoGiftCardInputProps) {
	return (
		<div className={classNames('promo-gift-cert__container')}>
			<div className="promo-gift-cert-field">
				<TextInput
					className="custom-input"
					placeholder="Enter voucher code"
					value={certificateProps.code ?? ''}
					onChange={event => {
						setCertificateProps({
							code: event.target.value,
							loading: false,
						});
						if (onCodeChange) {
							onCodeChange();
						}
					}}
					onKeyUp={event => {
						if (event.nativeEvent.code === 'Enter') {
							onApply();
						}
					}}
				/>
				<Button
					disabled={certificateProps.loading}
					className="apply-promo-button"
					display={Display.Solid}
					colors={Colors.Grey}
					onClick={onApply}
					newStyles
				>
					{/* The label stays "Apply" while it runs. Swapping it for "Applying voucher" grew the
					    button to most of the width of the field beside it, so the wait is said once,
					    below, where the result is said. */}
					Apply
					{certificateProps.loading && <LoaderInsideButton />}
				</Button>
			</div>
			{certificateProps.loading && (
				<div className="promo-gift-cert__message promo-gift-cert__message--pending" role="status">
					Applying voucher
				</div>
			)}
			{!certificateProps.loading && message && (
				<div
					className={classNames('promo-gift-cert__message', `promo-gift-cert__message--${message.type}`)}
					role="alert"
				>
					{message.text}
				</div>
			)}
		</div>
	);
}

export default observer(PromoGiftCardInput);
